import React, {useContext, useState} from "react";
import {login, resetPass} from "./api/PortalCustomerApi";
import {useNavigate} from "react-router-dom";
import {Grid, InputAdornment} from "@mui/material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import Divider from "@mui/material/Divider";
import {UserContext} from "../../lib/UserProvider";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function LoginForm({showCreateAccount, handleLogin, toggleShowForgotPassword}) {
  const [userContext, setUserContext] = useContext(UserContext);

  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [passwd, setPasswd] = useState('');
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    if (event.target.id === 'username') {
      setUsername(event.target.value);
    }
    if (event.target.id === 'passwd') {
      setPasswd(event.target.value);
    }
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    }
  };

  const loginFn = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const auth = {
      username: username,
      passwd: passwd,
      email: email,
    };

    setLoginError(null);
    setLoggingIn(true);
    let result = await login(auth);
    if (result.error) {
      setLoginError(result.message);
    } else {
      setUserContext({...userContext, sessionUser: result, refreshIdentity: true});
      setShowLogin(false);
      setUsername('');
      setPasswd('');

      handleLogin(result);

    }
    setLoggingIn(false);
  }
  return (
    <Grid container>
      <Grid item xs={12}>

        <form onSubmit={loginFn}>
          <Grid container>
            <Grid item xs={12}>
              <center>
                <MDTypography
                  variant="h5"
                  fontWeight="light"
                >Welcome Back!</MDTypography>
              </center>
              <MDBox>
                <Grid container p={1}>
                  <Grid item xs={12} sm={12}>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <MDInput type="email"
                               required
                               variant="outlined"
                               value={email || ''}
                               onChange={handleChange}
                               autoComplete="username-email"
                               className="form-control" id="email" aria-describedby="emailHelp"
                               placeholder="Enter email"/>
                    </div>
                  </Grid>
                </Grid>
                <Grid container p={1}>
                  <Grid item xs={12} sm={12}>
                    <div className="form-group">
                      <label htmlFor="passwd">Password</label>
                      <MDInput
                        variant="outlined"
                        value={passwd || ''}
                        InputProps={{
                          endAdornment: <InputAdornment style={{
                            cursor:'pointer',
                            height:'50px',
                            padding:'15px 5px'
                          }} position="end" onClick={(e) => {
                            setShowPassword(!showPassword);
                          }}>
                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon/>}
                          </InputAdornment>
                        }}
                        onChange={handleChange}
                        autoComplete="current-password"
                        type={showPassword ? "text" : "password"} className="form-control" id="passwd"
                        placeholder="Enter Password"
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} mt={1}>
                  <Grid item xs={12} sm={12}>
                    <MDTypography variant="h5" fontWeight="medium">

                      <center>
                        <p>
                          <MDButton type="submit" color="info" disabled={loggingIn}>
                            {loggingIn ? 'Signing in...' : 'Sign In'}
                          </MDButton>
                        </p>
                      </center>

                    </MDTypography>

                    {loginError && <div className={'d-block'} style={{
                      clear:'both',
                      width:'100%',
                      padding:'10px'
                    }}>
                      <p className={'text-center text-danger d-block'}>
                        The username and password you have entered do not match.<br/>
                        Please try again.
                      </p>
                    </div>
                    }

                  </Grid>

                </Grid>
              </MDBox>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <MDTypography variant="p" fontWeight="light">
            <Divider/>
            <center>
              <p className={'d-block'}>
                Just getting started?
              </p>
              <p>
                <MDButton
                  color="primary"
                  className={'link-underline-info cursor-pointer'}
                  onClick={() => {
                    showCreateAccount()
                  }}>Create Account</MDButton>
              </p>

              <p>
                <small>
                  <b style={{
                    fontWeight: '500'
                  }}>Signed a waiver in person?</b><br/>
                  An account was already created for you. <br/>
                  Click <a className={'link-underline-info cursor-pointer'} onClick={() => {
                  toggleShowForgotPassword();
                }}>Forgot Password</a> to set your password and access your account.
                </small>
              </p>
            </center>
          </MDTypography>
        </Grid>
      </Grid>
    </Grid>
  )
}